package com.loyola.acessoescola.services.quintadb


class FaceDetectionException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)

class InvalidImageURIException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)


class UploadException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)


class CreateRecordException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)

class UpdateRecordException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)

class DeleteRecordException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)

class UnauthorizedException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)


class ExpiredTokenException(
    message: String,
    cause: Throwable? = null
): Exception(message, cause)